import { useMemo } from 'react'
import ReactQuill from 'react-quill'
import classNames from 'classnames'
import 'react-quill/dist/quill.snow.css'
import './RichTextEditor.scss'

const defaultModules = {
  toolbar: [
    [{ header: [1, 2, 3, false] }],
    ['bold', 'italic', 'underline', 'strike'],
    [{ list: 'ordered' }, { list: 'bullet' }],
    [{ indent: '-1' }, { indent: '+1' }],
    ['link'],
    ['clean'],
  ],
}

const defaultFormats = [
  'header',
  'bold',
  'italic',
  'underline',
  'strike',
  'list',
  'bullet',
  'indent',
  'link',
]

const RichTextEditor = ({
  value,
  onChange,
  placeholder,
  rtl = false,
  className,
}) => {
  const modules = useMemo(() => defaultModules, [])
  const formats = useMemo(() => defaultFormats, [])

  return (
    <div
      className={classNames('rich-text-editor', { 'rich-text-editor--rtl': rtl }, className)}
    >
      <ReactQuill
        theme="snow"
        value={value ?? ''}
        onChange={onChange}
        modules={modules}
        formats={formats}
        placeholder={placeholder}
      />
    </div>
  )
}

export default RichTextEditor
